'use strict';

angular.module('internal.users')
    .directive('internalUserActions', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'users/components/user-actions/user-actions.html',
            replace: true,
            controller: 'InternalActions'
        };
    }])
;